function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_132",
  "data-name": "Group 132",
  transform: "translate(-646.732 -42)"
}, React.createElement("g", {
  id: "Ellipse_2",
  "data-name": "Ellipse 2",
  transform: "translate(650 42)",
  fill: "none",
  stroke: "#09b0ee",
  strokeWidth: 2
}, React.createElement("circle", {
  cx: 5.5,
  cy: 5.5,
  r: 5.5,
  stroke: "none"
}), React.createElement("circle", {
  cx: 5.5,
  cy: 5.5,
  r: 4.5,
  fill: "none"
})), React.createElement("line", {
  id: "Line_28",
  "data-name": "Line 28",
  x1: 5,
  y2: 6,
  transform: "translate(647.5 51.5)",
  fill: "none",
  stroke: "#09b0ee",
  strokeWidth: 2
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 14.268,
    height: 16.141,
    viewBox: "0 0 14.268 16.141"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/search.d244293f.svg";
export { SvgComponent as ReactComponent };